import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/iam/iam-product-img.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import "../services.scss"
import sec3Img from "../../../../../assets/website-images/services/s6.png";
import {useTranslation} from "react-i18next";


export default function CustomIDService() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'services'}>
            <PageBanner img={productPageImg} heading={t('services.custom_iam.banner_head')} bannerImg={productBannerImg}/>

            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6} xl={5} className={'d-flex align-items-center'}>
                            <img src={sec3Img} className={'img-fluid'}/>
                        </Col>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.custom_iam.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.custom_iam.sub_head')}</h3>
                            <p>{t('services.custom_iam.para_1')}</p>
                            <p>{t('services.custom_iam.para_2')}</p>
                            <p>{t('services.custom_iam.para_3')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}